export const OFFER_PARAM_KEYS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_content',
  'utm_term',
  'fbclid',
];

function isSignupPath(pathname) {
  return pathname === '/signup' || pathname.startsWith('/signup/');
}

export function withOfferParams(href, locationLike = {}) {
  if (!href || /^(https?:|mailto:|tel:|#)/i.test(href)) return href;
  const path = locationLike.pathname || '';
  const hashIndex = href.indexOf('#');
  const withoutHash = hashIndex >= 0 ? href.slice(0, hashIndex) : href;
  const splitAt = withoutHash.indexOf('?');
  const destPath = splitAt >= 0 ? withoutHash.slice(0, splitAt) : withoutHash;
  if (!path.startsWith('/offer/') && !isSignupPath(destPath)) return href;
  const incoming = new URLSearchParams(locationLike.search || '');
  const hash = hashIndex >= 0 ? href.slice(hashIndex) : '';
  const pathname = destPath;
  const dest = new URLSearchParams(splitAt >= 0 ? withoutHash.slice(splitAt + 1) : '');
  OFFER_PARAM_KEYS.forEach((key) => {
    const value = incoming.get(key);
    if (value && !dest.has(key)) dest.set(key, value);
  });
  const query = dest.toString();
  return `${pathname}${query ? `?${query}` : ''}${hash}`;
}
